<template>
  <v-row justify="center">
		<v-dialog :value="dialog" max-width="60%" persistent>
			<v-card>

        <v-card-title class="headline accent--text pb-4" v-if="selectedItem">
          {{selectedItem.application.personalCard.fullName}}
        </v-card-title>

        <v-card-text outlined tile class="border-top">
          <v-container>
            <v-row>
              <v-col cols="12" md="4" class="py-0 pt-6">
                <v-text-field
                  v-model="ratingLine[`${property1}`]"
                  :disabled="isShowMode"
                  @change="scoreFunc"
                  @focus="(e)=> e.target.select()"
                  v-mask="'#####'"
                  label="Категория А"
                  placeholder="Введите баллы"
                  outlined
                  rounded
                  dense
                />
              </v-col>

              <v-col cols="12" md="4" class="py-0 pt-6">
                <v-text-field
                  v-model="ratingLine[`${property2}`]"
                  :disabled="isShowMode"
                  @change="scoreFunc"
                  @focus="(e)=> e.target.select()"
                  v-mask="'#####'"
                  label="Категория Б"
                  placeholder="Введите баллы"
                  outlined
                  rounded
                  dense
                />
              </v-col>

              <v-col cols="12" md="4" class="py-0 pt-6">
                <v-text-field
                  v-model="ratingLine[`${property3}`]"
                  :disabled="isShowMode"
                  @change="scoreFunc"
                  @focus="(e)=> e.target.select()"
                  v-mask="'#####'"
                  label="Категория В"
                  placeholder="Введите баллы"
                  outlined
                  rounded
                  dense
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="ratingLine.score"
                  :disabled="isShowMode"
                  v-mask="'#####'"
                  label="Сумма баллов"
                  placeholder="Введите баллы"
                  outlined
                  rounded
                  dense
                />
              </v-col>

              <template v-if="!isShowMode">
                <v-col cols="12" md="4" class="py-0">
                  <v-text-field
                    v-model="amountThree"
                    :disabled="isShowMode"
                    @change="gpaFunc"
                    @focus="(e)=> e.target.select()"
                    v-mask="'#####'"
                    label="Количество троек"
                    placeholder="Введите количество троек"
                    outlined
                    rounded
                    dense
                  />
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <v-text-field
                    v-model="amountFour"
                    :disabled="isShowMode"
                    @change="gpaFunc"
                    @focus="(e)=> e.target.select()"
                    v-mask="'#####'"
                    label="Количество четвёрок"
                    placeholder="Введите количество четвёрок"
                    outlined
                    rounded
                    dense
                  />
                </v-col>

                <v-col cols="12" md="4" class="py-0">
                  <v-text-field
                    v-model="amountFive"
                    :disabled="isShowMode"
                    @change="gpaFunc"
                    @focus="(e)=> e.target.select()"
                    v-mask="'#####'"
                    label="Количество пятёрок"
                    placeholder="Введите количество пятёрок"
                    outlined
                    rounded
                    dense
                  />
                </v-col>
              </template>

              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="ratingLine.gpa"
                  :disabled="isShowMode"
                  v-mask="'#.###'"
                  label="Средний балл"
                  placeholder="Введите баллы"
                  outlined
                  rounded
                  dense
                />
              </v-col>

              <v-col cols="12" class="py-0">
                <v-autocomplete
                  v-model="ratingLine.scholarshipType"
                  :items="scholarshipTypes"
                  :disabled="isShowMode"
                  item-text="name"
                  label="Тип стипендии"
                  placeholder="Выберите из списка"
                  return-object
                  outlined
                  rounded
                  dense
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal">Закрыть</v-btn>
          <v-btn
            :loading="saveBtnLoading"
            :disabled="isShowMode"
            v-if="!isShowMode"
            color="success"
            text
            @click="saveRatingLine"
          >
            Принять
          </v-btn>
        </v-card-actions>
    </v-card>
		</v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { RatingLine } from '@/models'
import { scholarshipTypeApi } from '@/api'
import { setValidateMessages } from '@/scripts/validation'

export default {
  name: 'ApplicationCreate',

  props: {
    property1: String,
    property2: String,
    property3: String,
    dialog: Boolean,
    selectedItem: Object,
    saveBtnLoading: Boolean,
    isShowMode: Boolean
  },

  async created() {
    await this.loadCatalogs()
  },

  data() {
    return {
      ratingLine: new RatingLine(),
      scholarshipTypes: [],
      amountThree: 0,
      amountFour: 0,
      amountFive: 0
    }
  },

  computed: {
    ...mapGetters('user', ['userId']),

    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.protocolLine.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.protocolLine[key])
      })

      return allErrors
    },
  },

  methods: {
    async loadCatalogs() {
      const [scholarshipType] = await Promise.all([scholarshipTypeApi.getCatalog()])

      this.scholarshipTypes = scholarshipType
      // this.decisions = scholarshipType
    },

    scoreFunc() {
      this.ratingLine.score =
        +this.ratingLine[`${this.property1}`] +
        +this.ratingLine[`${this.property2}`] +
        +this.ratingLine[`${this.property3}`]
    },

    gpaFunc() {
      if(!this.amountThree) this.amountThree = 0
      if(!this.amountFour) this.amountFour = 0
      if(!this.amountFive) this.amountFive = 0

      if(this.amountThree || this.amountFour || this.amountFive) this.ratingLine.gpa =
        (((+this.amountThree * 3) + (+this.amountFour * 4) + (+this.amountFive * 5))/
          (+this.amountThree + +this.amountFour + +this.amountFive)).toFixed(3)
    },

    async saveRatingLine() {
      this.$emit('saveRatingLine', this.ratingLine)
    },

    resetModal() {
      this.ratingLine = new RatingLine()
    },

    closeModal() {
      this.resetModal()
      this.$emit('closeModal')
    },
  },

  watch: {
    async selectedItem(val) {
      this.ratingLine = val ? RatingLine.buildFromAPI(val) : new RatingLine()
    },

    dialog(val) {
      this.amountThree = 0
      this.amountFour = 0
      this.amountFive = 0
      !val && this.resetModal()
    }
  }
}
</script>
<style scoped>
  .border-top {
    border: 0 !important;
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  .theme--light.v-btn.v-btn--disabled {
    color: #dadada !important
  }
</style>
